/**
 * /t/$slug/login — public tenant login.
 *
 * Outside the admin auth guard — anyone with the URL can land
 * here. The LoginFlow runs the WebAuthn ceremony against the
 * tenant-scoped backend endpoints.
 */

import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { TenantLoginPage } from "@/features/auth/pages/tenant-login-page";

const tenantLoginSearchSchema = z.object({
  /** Absolute path to bounce to after a successful sign-in. */
  redirect: z.string().optional(),
  /** Pre-fill for operators following a one-click email link. */
  email: z.string().optional(),
  /**
   * Tenant display name override — the portal passes this so the
   * shell can render "Sign in to Acme" without an extra fetch.
   */
  brandName: z.string().optional(),
});

type TenantLoginSearch = z.infer<typeof tenantLoginSearchSchema>;

export const Route = createFileRoute("/t/$slug/login")({
  validateSearch: (raw: Record<string, unknown>): TenantLoginSearch =>
    tenantLoginSearchSchema.parse(raw),
  component: TenantLoginPage,
});
